<template>
  <el-tooltip :placement="placement" :content="content" popper-class="help-tip__popper">
    <i class="fa fa-info-circle text-muted help-tip__icon"
       role="img" tabindex="0" :aria-label="content" @click="onClick"></i>
  </el-tooltip>
</template>

<script>

export default {
  name: 'help-tip',

  props: {

    content: {
      type: String,
      required: true
    },

    placement: {
      type: String,
      default: 'top'
    },

    // XOL-674: opt-in. Set it when the icon sits inside a <label for=...> (a SwitchInput `label`
    // slot): a click on the icon would otherwise bubble to the label and toggle the control.
    // preventDefault stops the label's activation; the tooltip still opens (hover / focus).
    inLabel: {
      type: Boolean,
      default: false
    }

  },

  methods: {

    onClick (e) {
      if (this.inLabel) {
        e.preventDefault()
      }
    }

  }

}
</script>

<style scoped>
.help-tip__icon {
  margin-left: 4px;
  font-size: 12px;
  cursor: help;
}
</style>
